import React from 'react'
import { useBanks } from "../../hooks/use-banks"
import { SelectList } from "./select-list"

export const SelectMethod = ({ placeholder = '' }) => {
  const options = [
    { 
      icon: 'famicons:card-outline',
      key: 'spei',
      label: 'Transferencia a tu cuenta bancaria (SPEI)',
      activeEndIcon: 'mdi:bank-transfer-in'
    },
    { 
      icon: 'mdi:credit-card',
      key: 'card',
      label: 'Transferencia a tu tarjeta de débito',
      activeEndIcon: 'mdi:credit-card'
    }
  ]

  return (
    <SelectList
      showActiveEndIcon
      name="method"
      label="Selecciona el método de pago"
      required
      placeholder={placeholder}
      options={options}
    />
  )
}
